import { useAuthStore } from '@/stores/auth';

/** cross_tenant_admin が自分のテナント以外を操作中かどうかの共通判定。
 *  SystemAdminBanner (常時表示バナー) と Modal.tsx の ConfirmDialog (破壊的操作への警告追記) の
 *  両方から使う (v1.0 Phase4、docs/design/v10-phase4-platform-admin-ui.md §3-3)。 */
export function useIsActingAsSystemAdmin(): boolean {
  const user = useAuthStore((s) => s.user);
  return !!(
    user?.is_cross_tenant_admin
    && user.active_tenant_id
    && user.primary_tenant_id
    && user.active_tenant_id !== user.primary_tenant_id
  );
}
